/*
 * tree-menu.js - Add Assign as default to menu showing optional columns
 */
/* jshint esversion: 6 */
'use strict';

jQuery(document).ready(function () {
    Sao.View.Tree.prototype.save_optional_procentral = Sao.View.Tree.prototype.save_optional;
    Sao.View.Tree.prototype.save_optional = function(store=true) {
        if (this.screen.current_view.optionals_save_as_default) {
            this.save_optional_procentral(store);
        } else {
            var fields = {};
            for (let [name, columns] of Object.entries(this.optionals)) {
                fields[name] = columns.every(c => !c.get_visible());
            }
            Sao.Screen.tree_column_optional[this.view_id] = fields;
        }
    };

    Sao.View.Tree.prototype.tree_menu_procentral = Sao.View.Tree.prototype.tree_menu;
    Sao.View.Tree.prototype.tree_menu = function(evt) {
        this.tree_menu_procentral(evt);
        this.screen.current_view.optionals_save_as_default = false;

        const toggle = evt => {
            this.screen.current_view.optionals_save_as_default = jQuery(evt.delegateTarget).prop('checked');
            this.save_optional();
        };

        var menu = evt.data;
        menu.prepend(jQuery('<li/>', {
            'role': 'presentation'
        }).append(jQuery('<a/>', {
            'role': 'menuitem',
        }).append(jQuery('<label/>', {
            'class': 'toggle-switch',
        }).append(jQuery('<input/>', {
            'type': 'checkbox',
            'checked': false,
        }).change(toggle))
            .append('Assign as default'))));
    };
});
